module.exports = __webpack_public_path__ + "static/media/29DUNON9.927f1d09.jpg";